import type { ApplicationSettings } from "../store/schema/ApplicationSettings";
import type { ApplicationSettingsError, ApplicationSettingsReport, EcsRolloutConfig, } from "owa-analytics-types";

function getEcsRolloutConfig(ecsConfigIds: string): EcsRolloutConfig | undefined {
    const rolloutIds = new Set<string>();
    
    for (const entry of ecsConfigIds.split(",")) {
        const parts = entry.trim().split("-");
        if (parts.length === 5 && parts[0] === "P" && parts[1] === "R" && /^\d+$/.test(parts[2])) {
            rolloutIds.add(parts[2]);
        }
    }
    
    return rolloutIds.size > 0
        ? {
            EcsRolloutIds: [...rolloutIds].join(","),
        }
        : undefined;
}

export const generateApplicationSettingsReport = (receivedSettings: ApplicationSettings, receivedSettingsType: string, filters: string, ecsConfigIds: string, ecsETag?: string | null, lastError?: ApplicationSettingsError): ApplicationSettingsReport<ApplicationSettings> => {
    const report = {} as ApplicationSettingsReport<ApplicationSettings>;
    if (receivedSettingsType) {
        report.Type = receivedSettingsType;
    }
    
    report.Settings = receivedSettings;
    report.Filters = filters;
    
    // EcsConfigIds is optional and only populated once the server exposes the raw
    // config-ID list on the boot configuration. When absent the report omits the
    // field entirely so the empty value is not promoted to a payload key, which
    // matters because 1DS/Aria does not promote a consistently-empty key into a
    // Kusto column.
    if (ecsConfigIds) {
        report.EcsConfigIds = ecsConfigIds;
        Object.assign(report, getEcsRolloutConfig(ecsConfigIds));
    }
    
    // EcsETag is optional and only populated once the server exposes it on the
    // boot configuration. When absent the report omits the field entirely so
    // downstream stamping/serialization stays a no-op.
    if (ecsETag) {
        report.EcsETag = ecsETag;
    }
    
    if (lastError) {
        report.LastError = lastError;
    }
    
    return report;
};

export interface NoSettingsReport {
    NoSettings: boolean;
    LastError: ApplicationSettingsError;
}

export const getNoSettingsReport = (settingsError: ApplicationSettingsError): NoSettingsReport => ({
    NoSettings: true,
    LastError: settingsError,
});
